module.exports = __webpack_public_path__ + "img/btn_comment.209443ca.png";